import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import _ from 'lodash';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import TrafficLiveTraffic from './traffic-liveTraffic';
import TrafficTerminals from './traffic-terminals';
import TrafficGate from './traffic-gate';
var t = i18n.getFixedT(null, 'traffic-prediction');
var Traffic = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  });

  _objectDestructuringEmpty(_useSelector);

  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", {
    className: "trafficPrediction-traffic"
  }, /*#__PURE__*/React.createElement(TrafficLiveTraffic, null), /*#__PURE__*/React.createElement(TrafficTerminals, null), /*#__PURE__*/React.createElement(TrafficGate, null));
});
Traffic.propTypes = {};
export default Traffic;